<template>
   <div class="order-top">
       <div class="header">
           <div class="title">
               依最近的任務來指定
           </div>
       </div>
       <div class="list">
            <order-item v-for="order in orders" :order="order" :key="order.id"/>
           <div class="no-order" v-show="!orders.length">
               您目前尚未有完成的訂單
           </div>
       </div>
       <div class="more" v-show="orders.length" @click.stop="show">
           從任務紀錄尋找騎士
           <img src="@/assets/img/next-green.svg">
       </div>
   </div>
</template>

<script>
    import OrderItem from "./OrderItem";
    import { getOrderTop } from '../../../apis';

    export default {
        name: "OrderTop",
        components: {
            'order-item': OrderItem,
        },
        data() {
          return {
              orders: [],
          }
        },
        created() {
            getOrderTop(this.$route.params.type).then(res => {
                this.orders = res.data;
            });
        },
        methods: {
            show() {
                this.$router.push({
                    name: 'ordersList',
                    params: {
                        type: this.$route.params.type,
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .order-top {
        padding: 0 15px 15px 15px;

        .header {
            padding: 15px 10px;
            display: flex;
            justify-content: space-between;
            user-select: none;

            .title {
                color: #000;
                font-size: 18px;
                font-weight: 500;
            }
        }

        .list {
            .no-order {
                border-radius: 5px;
                background-color: #FAFAFA;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                color: #000000;
                font-size: 14px;
                padding: 25px 15px;
            }
        }

        .more {
            display: flex;
            justify-content: center;
            align-content: center;
            color: #339933;
            font-size: 18px;
            font-weight: 600;
            margin-top: 25px;
            cursor: pointer;
            user-select: none;
        }
    }
</style>